import { render, staticRenderFns } from "./statusBar.vue?vue&type=template&id=4ed36098&scoped=true"
import script from "./statusBar.vue?vue&type=script&lang=js"
export * from "./statusBar.vue?vue&type=script&lang=js"
import style0 from "./statusBar.vue?vue&type=style&index=0&id=4ed36098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed36098",
  null
  
)

export default component.exports